<div class="calls-leads-toggles">
  @if (isLeadsOn) {
    <button
      type="button"
      class="status-toggle is-on calls-on-button-mobile"
      (click)="leadsOff()"
      title="Leads are on — click to turn off"
    >
      <span class="sw" aria-hidden="true"></span>
      <i-lucide name="flag" [size]="12" [strokeWidth]="2.25" class="sw-ico" aria-hidden="true"></i-lucide>
      <span class="remove-on-mobile">Leads&nbsp;On</span>
    </button>
  } @else {
    <button
      type="button"
      class="status-toggle is-off calls-on-button-mobile"
      (click)="leadsOn()"
      title="Leads are off — click to turn on"
    >
      <span class="sw" aria-hidden="true"></span>
      <i-lucide name="flag" [size]="12" [strokeWidth]="2.25" class="sw-ico" aria-hidden="true"></i-lucide>
      <span class="remove-on-mobile">Leads&nbsp;Off</span>
    </button>
  }

  @if (isCallsOn) {
    <button
      type="button"
      class="status-toggle is-on calls-on-button-mobile"
      (click)="callsOff()"
      title="Calls are on — click to turn off"
    >
      <span class="sw" aria-hidden="true"></span>
      <i-lucide name="phone-call" [size]="12" [strokeWidth]="2.25" class="sw-ico" aria-hidden="true"></i-lucide>
      <span class="remove-on-mobile">Calls&nbsp;On</span>
    </button>
  } @else {
    <button
      type="button"
      class="status-toggle is-off calls-on-button-mobile"
      (click)="callsOn()"
      title="Calls are off — click to turn on"
    >
      <span class="sw" aria-hidden="true"></span>
      <i-lucide name="phone-call" [size]="12" [strokeWidth]="2.25" class="sw-ico" aria-hidden="true"></i-lucide>
      <span class="remove-on-mobile">Calls&nbsp;Off</span>
    </button>
  }
</div>
